import { Calendar, ChevronLeft, ChevronRight } from "../Icon/Icon";
import DatePicker, { ReactDatePickerCustomHeaderProps } from "react-datepicker";
import { HTMLProps, forwardRef, useState } from "react";
import InputWrapper from "../InputWrapper/InputWrapper";
import styles from "./DatePickerInput.module.scss";
import { format } from "date-fns";
import IconButton from "../IconButton/IconButton";

const CustomHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: ReactDatePickerCustomHeaderProps) => {
  return (
    <div className={styles.header}>
      <IconButton
        className={styles.headerButton}
        onClick={decreaseMonth}
        IconComponent={ChevronLeft}
        aria-label="Previous month"
        disabled={prevMonthButtonDisabled}
        showTooltip={false}
      />
      <span className={styles.headerDate}>{format(date, "MMMM yyyy ")}</span>
      <IconButton
        className={styles.headerButton}
        onClick={increaseMonth}
        IconComponent={ChevronRight}
        aria-label="Next month"
        disabled={nextMonthButtonDisabled}
        showTooltip={false}
      />
    </div>
  );
};

const CustomInput = forwardRef<HTMLInputElement, HTMLProps<HTMLInputElement>>(
  function CustomInput(props, ref) {
    return (
      <InputWrapper leftSection={<Calendar size="medium" />} ref={ref}>
        <input type="text" {...props} />
      </InputWrapper>
    );
  },
);

function DatePickerInput({
  className,
  value,
  onChange,
  placeholder,
  minDate,
  maxDate,
}: {
  className?: string;
  value?: Date;
  onChange?: (value: Date | null) => void;
  placeholder?: string;
  minDate?: Date;
  maxDate?: Date;
}) {
  const [uncontrolledValue, setUncontrolledValue] = useState<Date | null>(null);

  return (
    <div className={className}>
      <DatePicker
        selected={value ?? uncontrolledValue}
        onChange={onChange ? onChange : setUncontrolledValue}
        minDate={minDate}
        maxDate={maxDate}
        placeholderText={placeholder}
        dateFormat="MMM d, yyyy"
        customInput={<CustomInput />}
        renderCustomHeader={CustomHeader}
        calendarClassName={styles.container}
        dayClassName={() => styles.day}
        monthClassName={() => styles.month}
        weekDayClassName={() => styles.weekDay}
        popperClassName={styles.popper}
      />
    </div>
  );
}

export default DatePickerInput;
